export interface Product {
  imageUrl: string;
  productName: string;
  price: number;
}

export enum CheckoutType {
  hosted,
  modal,
  inline,
}

export interface CheckoutOptions {
  type: CheckoutType;
  language: string;
  showLanguageMenu: boolean;
  showHeader: boolean;
  log: boolean;
  merchantAccount: string;
  orderId: string;
  orderSummary: string;
}
